/**
 * @classdesc Chinese Language Pack
 * @desc This class will used to translate tokens into the Chinese language.
 * @namespace Languages.Chinese
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Chinese
 */
export const dictionary = {
	'years'   : '年',
	'months'  : '月',
	'days'    : '日',
	'hours'   : '时',
	'minutes' : '分',
	'seconds' : '秒'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Chinese
 */
export const aliases = ['zh', 'zh-cn', 'chinese'];
